import { atom } from "recoil"
import { Buckets } from "src/aws/customAPI"
const defaultState: Buckets[] = []
export const unreadThreadCountPerContactState = atom<Buckets[]>({
  key: "atoms/contact/unreadThreadCountPerContactState",
  default: defaultState,
})
